import preview from './preview.vue';
export default {
  components: {
    preview
  },
  data() {
    return {
      dialogVisible: false,
      templateCongfig: {}
    };
  },
  methods: {
    init(templateCongfig) {
      this.templateCongfig = JSON.parse(templateCongfig);
      this.dialogVisible = true;
    }
  }
};